module.exports = __webpack_public_path__ + "static/img/R142B.dc2f366.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/oem/R142B.jpg
// module id = 3ZKk
// module chunks = 1